module.exports = __webpack_public_path__ + "assets/img/pane2.88644575.jpg";